import * as PIXI from "pixi.js";

import { SingleInstanceClass } from "@src/core/utils/SingleInstanceClass";

// Wrapper that handles the creation/initialization and starting of the game application
export class GameApplication extends SingleInstanceClass {
  private _app: PIXI.Application | undefined = undefined;
  public get app(): PIXI.Application | undefined {
    return this._app;
  }

  public async create(): Promise<void> {
    if (!this._app) {
      this._app = new PIXI.Application();
    } else {
      throw new Error("Application has already been created.");
    }

    await this._app.init({
      background: "#000",
      resizeTo: window,
      resolution: window.devicePixelRatio || 1,
      autoDensity: true,
      autoStart: false,
    });

    document.body.appendChild(this._app.canvas as HTMLCanvasElement);
  }

  // TODO: Maybe add a stop method? If necessary
  public start(): void {
    if (!this._app) {
      throw new Error("Trying to start an invalid Application instance.");
    }

    if (this._app.ticker.started) {
      throw new Error("Trying to start the application more than once.");
    }

    this._app.start();
  }
}
